const variants = {
  primary:   'bg-primary-gradient text-white hover:opacity-90 shadow-md shadow-primary-600/25 focus:ring-primary-500',
  secondary: 'bg-white text-slate-700 border border-slate-200 hover:bg-slate-50 hover:border-slate-300 focus:ring-slate-400 shadow-card',
  danger:    'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500 shadow-md shadow-red-600/20',
  success:   'bg-emerald-600 hover:bg-emerald-700 text-white focus:ring-emerald-500 shadow-md shadow-emerald-600/20',
  ghost:     'bg-transparent hover:bg-slate-100 text-slate-600 hover:text-slate-900 focus:ring-slate-400 border border-transparent hover:border-slate-200',
  outline:   'bg-transparent border border-primary-500 text-primary-600 hover:bg-primary-50 focus:ring-primary-500',
};

const sizes = {
  sm: 'px-3 py-1.5 text-xs gap-1.5',
  md: 'px-4 py-2 text-sm gap-2',
  lg: 'px-6 py-3 text-base gap-2',
};

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  fullWidth = false,
  onClick,
  type = 'button',
  className = '',
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled || loading}
    className={`
      inline-flex items-center justify-center font-medium rounded-xl
      focus:outline-none focus:ring-2 focus:ring-offset-2
      transition-all duration-150 active:scale-[0.98]
      disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100
      ${variants[variant]}
      ${sizes[size]}
      ${fullWidth ? 'w-full' : ''}
      ${className}
    `}
  >
    {loading ? (
      <svg className="animate-spin w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
      </svg>
    ) : null}
    {children}
  </button>
);

export default Button;
